import { render, staticRenderFns } from "./airporttransfer.vue?vue&type=template&id=72a9750c&scoped=true&"
import script from "./airporttransfer.vue?vue&type=script&lang=js&"
export * from "./airporttransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9750c",
  null
  
)

export default component.exports